import { useState } from 'react';

// The /evals pages sit outside the app's normal JWT/domain
// auth (see server/src/blueprintEvals.ts) — they're gated by a single
// shared password instead, sent as a manually-built HTTP Basic Auth header.
// The password is kept in sessionStorage (not localStorage) so it survives
// a page reload within the tab but doesn't linger indefinitely on a shared
// machine.

const STORAGE_KEY = 'blueprintEvalsPassword';

export function useBlueprintEvalsAuth() {
  const [password, setPasswordState] = useState<string>(
    () => sessionStorage.getItem(STORAGE_KEY) || ''
  );

  const setPassword = (value: string) => {
    setPasswordState(value);
    if (value) {
      sessionStorage.setItem(STORAGE_KEY, value);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  };

  const authHeaders = (pw: string = password): Record<string, string> => ({
    Authorization: `Basic ${btoa(`:${pw}`)}`,
  });

  return { password, setPassword, authHeaders };
}
